<template lang="pug">
.success-card-info.sign-in
  .main-title
    img.success-img(:src="successImg")
  .card-content
    .card-info(v-if="cardInfo")
      .card-main-content
        .card-title {{ cardInfo.cardMainTitle }}
        .card-desc
          highlight-text(
            v-if="cardInfo.cardSubTitle"
            :text="cardInfo.cardSubTitle"
            :normalStyle="normalStyle"
            :highlightStyle="highlightStyle"
          )
          .card-use-attr(v-if="cardInfo.useTip") {{ cardInfo.useTip }}
        .card-price(v-if="cardInfo.cardPrice")
          span 价值
          span.num {{ cardInfo.cardPrice }}
          span 元
    .bottom-desc(v-if="cardInfo && cardInfo.useDesc")
      .desc-item(v-for="desc in cardInfo.useDesc")
        highlight-text(
          :text="desc"
          :normalStyle="descNormalStyle"
          :highlightStyle="descHighlightStyle"
        )
  //- 签约成功按钮（使用独立组件）
  .button-wrapper
    SuccessActionButton(
      :buttonText="buttonText"
      @click="handleButtonClick"
    )
</template>

<script>
import highlightText from '@/components/highlight-text.vue';
import SuccessActionButton from './success-action-button.vue';

export default {
  name: 'SuccessCardInfo',
  components: {
    highlightText,
    SuccessActionButton,
  },
  props: {
    cardInfo: {
      type: Object,
      default: () => ({
        cardMainTitle: '',
        cardSubTitle: '',
        cardPrice: '',
        useTip: '',
        isAppOnly: false,
        useDesc: [],
      }),
    },
    buttonText: {
      type: String,
      default: '去换电',
    },
  },
  data() {
    return {
      successImg: 'https://m.hellobike.com/resource/gallery/919/4tCh_aKDEZ.png',
      normalStyle: {
        color: '#fff',
        fontSize: '0.126rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
      },
      highlightStyle: {
        color: '#fff',
        fontSize: '0.25rem',
        fontWeight: 500,
        fontFamily: 'DINAlternate',
        marginRight: '0.04rem',
      },
      descHighlightStyle: {
        color: '#242729',
        fontSize: '0.12rem',
        fontWeight: 500,
      },
      descNormalStyle: {
        color: '#879099',
        fontSize: '0.12rem',
        fontWeight: 400,
      },
    };
  },
  methods: {
    handleButtonClick() {
      this.$emit('button-click');
    },
  },
};
</script>

<style lang="less" scoped>
.success-card-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0.2rem;
  position: relative;
  background: url('https://m.hellobike.com/1d2d2159_Frame_3%20(1).png') no-repeat top center;
  background-size: 100% auto;
  border-radius: 0.2rem;
  background-color: #fff;

  &.sign-in {
    padding-bottom: 0.3rem;
  }

  .main-title {
    text-align: center;
    padding: 0.2rem 0;

    .success-img {
      width: 2.75rem;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }

  .card-content {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding: 0 0.2rem;
    box-sizing: border-box;

    .card-info {
      width: 3.12rem;
      height: 0.96rem;
      box-sizing: content-box;
      padding: 0 0.09rem 0.19rem;
      background: url('https://m.hellobike.com/2210e352b2.png') no-repeat center/100% 100%;
      position: relative;
      align-self: center;

      .card-main-content {
        box-sizing: border-box;
        padding: 0.14rem 0.17rem 0;
        position: relative;
        height: 100%;

        .card-title {
          font-size: 0.16rem;
          color: #fff;
          font-weight: 600;
          font-family: 'DINAlternate', sans-serif;
          letter-spacing: 0.008rem;
          padding-top: 0.04rem;
        }

        .card-desc {
          margin-top: 0.06rem;
          display: flex;
          align-items: baseline;

          .card-use-attr {
            font-size: 0.095rem;
            color: rgba(255, 255, 255, 0.7);
            font-weight: 400;
            margin-left: 0.05rem;
          }
        }

        .card-price {
          font-size: 0.12rem;
          color: rgba(255, 255, 255, 0.5);
          font-weight: 600;
          margin-top: 0.06rem;
          display: flex;
          align-items: baseline;
          position: absolute;
          right: 0.13rem;
          bottom: 0.1rem;

          .num {
            font-size: 0.18rem;
            font-weight: 700;
            font-family: 'DINAlternate', sans-serif;
          }
        }
      }
    }
  }

  // 按钮容器（与 newClient 布局一致）
  .button-wrapper {
    margin-top: 0.37rem;
  }
}
</style>
